// Internal modules
import { appStore } from './store';
import { ADDRESS_GROUP_REGEX } from './models/constants';
import type {
  FormAddressState,
  FormAddressTypes,
  FormAddressUpdate,
  NoneAddressInputs,
} from './models/form/types';
import type { DefaultInputState } from './models';
import type { RecursivePartial } from '@/types';

type AddressFieldType<T extends FormAddressTypes> = keyof FormAddressState[T];
type AddressPayload<T extends FormAddressTypes> = RecursivePartial<
  FormAddressState[T]
>;

type DispatchFormActionNonAddress = {
  addressType?: undefined;
  field: keyof NoneAddressInputs;
  isBatchUpdate?: boolean;
  payload: Partial<DefaultInputState<unknown>>;
};

type DispatchFormActionAddress = {
  addressType: FormAddressTypes;
  field?: AddressFieldType<FormAddressTypes>;
  isBatchUpdate?: boolean;
  payload: AddressPayload<FormAddressTypes>;
};

const dispatchFormAction = ({
  addressType,
  field,
  isBatchUpdate = false,
  payload,
}: DispatchFormActionNonAddress | DispatchFormActionAddress): void => {
  const { form: formActions } = appStore.getActions();
  const isAddressField = ADDRESS_GROUP_REGEX.test(addressType || '');

  if (isAddressField && addressType) {
    const data: FormAddressUpdate<FormAddressTypes> = {
      ...(isAddressField && { addressType, isBatchUpdate }),
      field,
      payload,
    };
    return formActions.updateAddressField(data);
  }

  const data = {
    field: field as keyof NoneAddressInputs,
    payload: payload as Partial<DefaultInputState<unknown>>,
  };
  return formActions.updateNonAddressField(data);
};

export { dispatchFormAction };
